<template>
  <div class="image-options-setting-dialog">
    <div class="content-group-default">
      <div class="setting-item">
        <el-collapse v-model="activeNames">
          <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
          <el-collapse-item title="形状" name="1" v-if="!loginCodeImage">
            <div class="font-arrangement-btn">
              <span class="btn-active" :style="getTranslate"></span>
              <el-tooltip
                v-for="(val, index) in shapeTypeList"
                :key="index"
                class="item"
                effect="dark"
                :content="val.title"
                placement="top-end"
                :open-delay="1000"
              >
                <span
                  :key="index"
                  :class="shapeType == val.label ? 'select pd2' : 'pd2'"
                  @click="changeShapeType(val.label)"
                >
                  <i :class="val.className"></i>
                </span>
              </el-tooltip>
            </div>
          </el-collapse-item>
          <el-collapse-item title="边框" name="2">
            <div>
              <div class="content-item verticallyCenter">
                <el-checkbox v-model="showBorder">显示边框</el-checkbox>
              </div>
              <div v-if="showBorder" class="mt12">
                <cx-border
                  :borderWidth.sync="borderWidth"
                  :borderStyle.sync="borderStyle"
                  :borderColor.sync="borderColor"
                  :borderIsThemeColor.sync="borderIsThemeColor"
                />
              </div>
            </div>
            <div v-if="shapeType == 'radius' && shapeChecked" class="content-item mt16">
              <border-radius
                :borderTypeFlag.sync="borderTypeFlag"
                :borderRadius.sync="borderRadius"
                :borderTopLeftRadius.sync="borderTopLeftRadius"
                :borderTopRightRadius.sync="borderTopRightRadius"
                :borderBottomRightRadius.sync="borderBottomRightRadius"
                :borderBottomLeftRadius.sync="borderBottomLeftRadius"
              />
            </div>
          </el-collapse-item>
          <el-collapse-item title="显示效果" name="3">
            <div v-if="activeNames.includes('3')" class="content">
              <img-crop :clipSize.sync="clipSize" :repeatType.sync="repeatType" :alignType.sync="alignType" />
            </div>
          </el-collapse-item>
          <el-collapse-item title="更多" name="4">
            <div class="content">
              <div class="content-item mb16">
                <slider-and-input :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
              </div>
              <widthAndSizeAndZindex
                :options="options"
                :ids="ids"
                showSetItem="rotate"
                class="mb16"
                v-if="request_prefix !== 'bigScreen'"
              />
              <div class="content-item">
                <div class="checkbox_colorPicker_container">
                  <span>阴影</span>
                  <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow"></span>
                </div>
                <box-shadow
                  :boxShadowH.sync="boxShadowH"
                  :boxShadowV.sync="boxShadowV"
                  :boxShadowBlur.sync="boxShadowBlur"
                  :boxShadowSpread.sync="boxShadowSpread"
                  :boxShadowColor.sync="boxShadowColor"
                />
              </div>
              <div class="content-item mb12">
                <public-style :options="options" :ids="ids"></public-style>
              </div>
              <div v-if="!loginCodeImage" class="mb12">
                <cx-check-box :value.sync="zoomToView">开启图片放大查看</cx-check-box>
                <div v-if="zoomToView">
                  <div class="content-item mt16 verticallyCenter">
                    <div class="fs14 mr16">图标位置</div>
                    <ul class="position-style-ul">
                      <li
                        v-for="(item, index) in positionList"
                        :key="index"
                        :class="zoomPosition == item ? 'selected' : ''"
                        @click="changeZoomPosition(item)"
                      ></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div v-if="clipSize === 'cover' || clipSize === 'auto 100%'" class="image-compression">
                <cx-check-box :value.sync="compression">图片压缩</cx-check-box>
                <i class="tips-btn icon-portal-info2" @click.stop.prevent="explainDialog = true"></i>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item v-show="$store.state.states.showPluginSetting" title="插件" name="5">
            <div class="setting-item">
              <elementPluginSetting :pluginName="pluginName" :myid="ids"></elementPluginSetting>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips">开启图片压缩后可以提高页面加载速度，但会降低图片的清晰度。</p>
    </el-dialog>
  </div>
</template>

<script>
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import widthAndSizeAndZindex from "publicSetting/widthAndSizeAndZindex.vue"
import elementPluginSetting from "publicSetting/elementPluginSetting.vue"
import { withMethodsHistoryCombine } from "utils/revork"
import publicStyle from "publicSetting/publicStyle.vue"
export default withMethodsHistoryCombine({
  name: "image-options-data",
  components: { controlWidthAndSizeAndZindex, widthAndSizeAndZindex, elementPluginSetting, publicStyle },
  props: { options: Object },
  data() {
    return {
      this1: this,
      activeType: 1,
      sliderMax: 360,
      activeNames: [],
      hoverOpt: [],
      shapeTypeList: [
        {
          className: "icon-portal-square",
          label: "square",
          title: "正方形"
        },
        {
          className: "icon-portal-rectangle",
          label: "rectangle",
          title: "矩形"
        },
        {
          className: "icon-portal-rounded-rectangle",
          label: "radius",
          title: "圆角矩形"
        },
        {
          className: "icon-portal-round",
          label: "round",
          title: "圆形"
        }
      ],
      borderStyleList: [
        {
          value: "solid",
          label: "实线",
          title: "",
          src: require("assets/images/solid-1.png")
        },
        {
          value: "dashed",
          label: "虚线",
          title: "",
          src: require("assets/images/dashed-1.png")
        },
        {
          value: "dotted",
          label: "点线",
          title: "",
          src: require("assets/images/dotted-1.png")
        }
      ],
      hoverBorderStyleList: [
        {
          value: "solid",
          label: "实线",
          title: "",
          src: require("assets/images/solid-1.png")
        },
        {
          value: "dashed",
          label: "虚线",
          title: "",
          src: require("assets/images/dashed-1.png")
        },
        {
          value: "dotted",
          label: "点线",
          title: "",
          src: require("assets/images/dotted-1.png")
        }
      ],
      imgHoverStyleList: [
        {
          value: "normal",
          title: "无效果",
          src: require("assets/images/image/hover-no.png")
        },
        {
          value: "border",
          title: "边框",
          src: require("assets/images/image/hover-border.png")
          // }, {
          //   value: "mg",
          //   title: "放大镜",
          //   src: require("../../../assets/images/image/hover-fdj.png")
          // }, {
          //   value: "changeImg",
          //   title: "换图",
          //   src: require("../../../assets/images/image/hover-ht.png")
        },
        {
          value: "imgScale",
          title: "图片放大",
          src: require("assets/images/image/hover-tpfd.png")
        },
        {
          value: "leftMove",
          title: "左位移",
          src: require("assets/images/image/hover-zy.png")
        },
        {
          value: "topMove",
          title: "上位移",
          src: require("assets/images/image/hover-sy.png")
          // }, {
          //   value: "masking",
          //   title: "蒙版",
          //   src: require("../../../assets/images/image/hover-mb.png")
        },
        {
          value: "boxShadow",
          title: "底部阴影",
          src: require("assets/images/image/hover-dbyy.png")
        }
      ],
      // hoverBorderStyleSelect: '',
      uploadImgSrcDef: require("assets/images/image_placeholder.png"),
      translate: 0,
      positionList: ["left top", "right top", "left bottom", "right bottom"],
      explainDialog: false
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    pluginName: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "pluginName", "pluginName", [])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pluginName", false)
      }
    },
    loginCodeImage() {
      return this.options.loginType === "loginCodeImage"
    },
    activeRect() {
      let ids = this.$store.state.states.activeID
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        return this.$store.state.states.activeID
      } else return null
    },
    shapeChecked: {
      get() {
        return this.options.shapeChecked
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "shapeChecked", false)
      }
    },
    borderChecked: {
      get() {
        return this.options.borderChecked
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderChecked", false)
      }
    },
    borderShadowChecked: {
      get() {
        return this.options.borderShadowChecked
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderShadowChecked", false)
      }
    },
    rotateChecked: {
      get() {
        return this.options.rotateChecked
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "rotateChecked", false)
      }
    },
    shapeType: {
      get() {
        let index = this.shapeTypeList.findIndex(item => item.label === this.getOptions.shapeType)
        // 55 一个滑块的宽度
        this.translate = 55 * index
        return this.getOptions.shapeType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "shapeType", false)
      }
    },
    getTranslate() {
      return {
        transform: `translateX(${this.translate}px)`
      }
    },
    borderTypeFlag: {
      get() {
        return this.options.borderTypeFlag || 2
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    borderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderRadius", "borderRadius", this.borderTopLeftRadius)
      },
      set(newVal) {
        if (this.borderTypeFlag === 2) {
          this.$changeOptionsEV(
            [newVal, newVal, newVal, newVal, newVal],
            [
              "borderTopLeftRadius",
              "borderTopRightRadius",
              "borderBottomLeftRadius",
              "borderBottomRightRadius",
              "borderRadius"
            ],
            false
          )
        } else {
          this.$changeOptionsEV(newVal, "borderRadius", false)
        }
      }
    },
    borderTopLeftRadius: {
      get() {
        return this.options.borderTopLeftRadius
      },
      set(newVal) {
        if (this.borderTypeFlag === 2) {
          this.$changeOptionsEV(
            [parseInt(newVal), parseInt(newVal), parseInt(newVal), parseInt(newVal)],
            ["borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius", "borderTopLeftRadius"],
            false
          )
        } else {
          this.$changeOptionsEV(parseInt(newVal), "borderTopLeftRadius", false)
        }
      }
    },
    borderTopRightRadius: {
      get() {
        return this.options.borderTopRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return this.options.borderBottomRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return this.options.borderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    borderStyle: {
      get() {
        return this.options.borderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderStyle", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderIsThemeColor", "borderIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderIsThemeColor", false)
      }
    },
    borderColor: {
      get() {
        return this.options.borderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderColor", false)
      }
    },
    showBorder: {
      get() {
        let showBorder = false
        if (this.options.showBorder === undefined) {
          if (this.options.borderWidth) {
            showBorder = true
          } else {
            showBorder = false
          }
        } else {
          showBorder = this.options.showBorder
        }
        return showBorder
      },
      set(newVal) {
        if(newVal && !this.borderWidth) {
          this.$changeOptionsEV([1, newVal], ["borderWidth", "showBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showBorder", false)
        }
      }
    },
    borderWidth: {
      get() {
        return this.options.borderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderWidth", false)
      }
    },
    boxShadowColor: {
      get() {
        return this.options.boxShadowColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.options.boxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.options.boxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.options.boxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.options.boxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
    rotate: {
      get() {
        return parseInt(this.options.rotate)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "rotate", false)
      }
    },
    clipSize: {
      get() {
        return this.options.hasOwnProperty("clipSize") ? this.options.clipSize : "auto auto"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "clipSize", false)
      }
    },
    repeatType: {
      get() {
        return this.options.hasOwnProperty("repeatType") ? this.options.repeatType : "no-repeat"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "repeatType", false)
      }
    },
    alignType: {
      get() {
        return this.options.hasOwnProperty("alignType") ? this.options.alignType : "left top"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "alignType", false)
      }
    },
    zoomToView: {
      get() {
        return this.options.hasOwnProperty("zoomToView") ? this.options.zoomToView : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "zoomToView", false)
      }
    },
    zoomPosition: {
      get() {
        return this.options.hasOwnProperty("zoomPosition") ? this.options.zoomPosition : "right bottom"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "zoomPosition", false)
      }
    },
    opacity: {
      get() {
        return this.options.hasOwnProperty("opacity") ? this.options.opacity : 100
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "opacity", false)
      }
    },
    width: {
      get() {
        return this.getOptions.width
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "width", false)
      }
    },
    height: {
      get() {
        return this.getOptions.height
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "height", false)
      }
    },
    getOptions: function () {
      return this.$getOptions()
    },
    compression: {
      get() {
        if(this.options.compression === undefined) {
          this.$changeOptionsEV(false, "compression", false, false, false, true)
        }
        return this.getOptions.compression
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "compression", false)
      }
    }
  },
  methods: {
    switchHandle(type) {
      this.activeType = type
      if (type == 2) {
        this.changeHoverBorderSelection()
      }
    },
    changeShapeType(value) {
      this.shapeType = value
      this.borderTypeFlag = 2
      switch (value) {
        case "square":
          this.borderRadius = 0
          this.borderTopLeftRadius = 0
          this.borderTopRightRadius = 0
          this.borderBottomLeftRadius = 0
          this.borderBottomRightRadius = 0
          this.height = 400
          break
        case "rectangle":
          this.borderRadius = 0
          this.borderTopLeftRadius = 0
          this.borderTopRightRadius = 0
          this.borderBottomLeftRadius = 0
          this.borderBottomRightRadius = 0
          this.height = 225
          break
        case "radius":
          this.borderRadius = 10
          this.borderTopLeftRadius = 10
          this.borderTopRightRadius = 10
          this.borderBottomLeftRadius = 10
          this.borderBottomRightRadius = 10
          break
        case "round":
          this.borderRadius = "50%"
          this.borderTopLeftRadius = "50%"
          this.borderTopRightRadius = "50%"
          this.borderBottomLeftRadius = "50%"
          this.borderBottomRightRadius = "50%"
      }
    },
    changeBorderRadiusType(value) {
      this.borderTypeFlag = value
    },
    changeBorderSelection() {
      let path = this.borderStyleList.filter(borderStyle => {
        return borderStyle.value == this.borderStyle
      })[0].src
      if (!this.$refs.borderStyleSelect || !this.$refs.borderStyleSelect.$el) {
        return
      }
      this.$refs.borderStyleSelect.$el.children[0].children[0].setAttribute(
        "style",
        "background-image:url(" + path + ")!important;"
      )
    },
    changeHoverBorderSelection() {
      let path = this.hoverBorderStyleList.filter(hoverBorderStyle => {
        return hoverBorderStyle.value == this.hoverBorderStyle
      })[0].src
      this.$refs.hoverBorderStyleSelect.$el.children[0].children[0].setAttribute(
        "style",
        "background-image:url(" + path + ")!important;"
      )
    },
    checkboxHandle(flag) {
      switch (flag) {
        case 1:
          this.shapeType = "square"
          this.borderTopLeftRadius = 0
          this.borderTopRightRadius = 0
          this.borderBottomLeftRadius = 0
          this.borderBottomRightRadius = 0
          break
        case 2:
          if (!this.borderChecked) {
            this.borderColor = "#FFFFFF"
            this.borderWidth = 0
            this.borderStyle = "solid"
          } else {
            this.borderColor = "#FFFFFF"
            this.borderWidth = 1
            this.borderStyle = "solid"
            this.changeBorderSelection()
          }
          break
        case 3:
          this.boxShadowColor = "#FFFFFF"
          this.boxShadowH = 0
          this.boxShadowV = 0
          this.boxShadowBlur = 0
          this.boxShadowSpread = 0
          break
        case 4:
          this.rotate = "0deg"
          break
      }
    },
    changeHoverType(cur) {
      this.hoverType = cur
      switch (cur) {
        case "border":
          this.changeHoverBorderSelection()
          break
      }
    },
    addBoxshadow() {
      if (!Array.isArray(this.boxShadowH) || !Array.isArray(this.boxShadowColor)) {
        this.boxShadowH = [this.boxShadowH]
        this.boxShadowV = [this.boxShadowV]
        this.boxShadowBlur = [this.boxShadowBlur]
        this.boxShadowSpread = [this.boxShadowSpread]
        this.boxShadowColor = [this.boxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    },
    changeZoomPosition(value) {
      this.zoomPosition = value
    }
  }
})
</script>

<style scoped lang="scss">
.el-select .el-input .el-input__inner {
  padding-right: 32px;
}

.image-hover-set {
  font-size: 0;
  & > li {
    display: inline-block;
    vertical-align: top;
    width: 60px;
    margin-bottom: 24px;
    margin-right: 20px;
    cursor: pointer;
    &:nth-child(3n) {
      margin-right: 0;
    }
    .img-box {
      width: 60px;
      height: 60px;
      margin: 0 auto;
      overflow: hidden;
      border: 1px solid #e9e9e9;
      box-sizing: border-box;
      border-radius: 4px;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .name {
      text-align: center;
      margin-top: 8px;
      font-size: 12px;
      line-height: 17px;
      color: rgba(0, 0, 0, 0.6);
    }
    .select-flag {
      display: none;
      width: 24px;
      height: 24px;
      background: url("../../../assets/images/image/hover-select.png") no-repeat center;
      background-size: cover;
      position: absolute;
      right: -1px;
      bottom: -1px;
    }
    &.select {
      .img-box {
        border: 2px solid var(--themeColor);
      }
      .select-flag {
        display: block;
      }
    }
  }
}

.bigScreen-toolbar .image-hover-set {
  & > li {
    margin-right: 16px;
  }
  &:nth-child(3n) {
    margin-right: 16px;
  }
  &:nth-child(3n) {
    margin-right: 0;
  }
  .name {
    color: inherit;
  }
}

.font-arrangement-btn {
  flex: 1 1 0%;
}
.font-arrangement-btn span {
  width: calc((100% / 4));
}
.font-arrangement-btn span.btn-active {
  width: calc((100% - 6px) / 4);
}
.position-style-ul {
  width: 36px;
  font-size: 0;
  margin-left: 4px;
}

.position-style-ul > li {
  display: inline-block;
  width: 16px;
  height: 16px;
  opacity: 0.3;
  background: var(--themeColor);
  border-radius: 1px;
  margin: 2px 2px 0 0;
  cursor: pointer;
}

.position-style-ul > li.selected {
  opacity: 1;
}
.image-compression {
  display: flex;
  align-items: center;
}
</style>
